import React from 'react';
import { useIntl } from 'react-intl';
import {
  CourseSchemeResource,
  EventSchemeResource,
} from 'src/interfaces/reservation_flow';
import Linkify from 'react-linkify';
import StringUtils from 'src/components/utils/StringUtils';
import { DraftWysiwygViewer } from 'src/templates/merchants/resources/book/components/resource-detail-modal/DraftWysiwygViewer';
import { MerchantDetail } from 'src/interfaces/merchants';
import { RSButton } from 'src/reservation-page/RSButton';
import { RSDetailHeader } from 'src/reservation-page/detail-header/RSDetailHeader';

export interface BookingPageDetailTemplateProps {
  resource: CourseSchemeResource | EventSchemeResource;
  merchantDetail: MerchantDetail;
  handleClick: () => void;
}

export const BookingPageDetailTemplate: React.FC<
  BookingPageDetailTemplateProps
> = ({ resource, merchantDetail, handleClick }) => {
  const intl = useIntl();

  return (
    <>
      <RSDetailHeader title={merchantDetail.display_name} />

      <div className="flex justify-center">
        <div className="pc:max-w-[496px] pc:pt-4 mx-2.5 w-full pt-3">
          <div>
            {resource.primary_image && (
              <img
                className="mb-2"
                src={resource.primary_image.thumb_url}
                width="100%"
                height="auto"
                alt="primary image"
              />
            )}
          </div>

          <div className="rs-font text-16 text-gray-1000 pc:text-20 mb-2 font-bold">
            {resource.name}
          </div>

          <div className="space-y-6">
            {(() => {
              if (resource.description !== null) {
                return <DraftWysiwygViewer value={resource.description} />;
              }

              if (resource.description_text !== null) {
                return (
                  <Linkify>
                    {StringUtils.simpleFormat(resource.description_text)}
                  </Linkify>
                );
              }

              return null;
            })()}
          </div>

          <div className="mb-9 mt-6 flex w-full">
            <RSButton variant="basic" onClick={handleClick} isBlock={true}>
              {intl.formatMessage({
                defaultMessage: '次へ',
                id: 'J5xCcp',
                description:
                  'src/templates/merchants/resources/book/BookingPageDetailTemplate/index.tsx',
              })}
            </RSButton>
          </div>
        </div>
      </div>
    </>
  );
};
